module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/accountmaster/inactive-dormand-grid/inactive-dormand-grid.component.css
// module id = ./src/app/accountmaster/inactive-dormand-grid/inactive-dormand-grid.component.css
// module chunks = main